import { getTimesheetCounts, fetchPayPeriods } from "../api/home";

// Function to grab pay periods
const grabPayPeriods = async (): Promise<any> => {

    try {
        // Make the API request to fetch pay periods
        const apiResults = await fetchPayPeriods();

        // Check if the API results are not returned or empty, throw an error
        if (!apiResults) { 
            throw new Error("Fetch Failed.");
        }

        // Store the results from the API response
        const authData = apiResults;

        // Return the authData to be used elsewhere
        return authData;

    } catch (err) {
        // Log any errors encountered during the fetch
        console.error("Error in fetchPayPeriods", err);

        // Throw the error for handling in calling code
        throw err;
    }

};

// Function to grab timesheet counts
const grabCounts = async (payPeriodID: number, supervisorID: number): Promise<any> => {

    try {
        // Make the API request to fetch timesheet counts
        const apiResults = await getTimesheetCounts(payPeriodID, supervisorID);

        // Check if the API results are not returned or empty, throw an error
        if (!apiResults) { 
            throw new Error("Fetch Failed.");
        }

        // Store the results from the API response
        const authData = apiResults;

        // Return the authData to be used elsewhere
        return authData;

    } catch (err) {
        // Log any errors encountered during the fetch
        console.error("Error in getTimesheetCounts", err);

        // Throw the error for handling in calling code
        throw err;
    }

};

// Export the functions to be used in other parts of the application
export { grabPayPeriods, grabCounts };
